module.exports = __webpack_public_path__ + "static/minotaur_skeleton-a1530e6df59b1bf493ad41016dce4598.jpeg";